/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Fields_EmptyInputs */

const cs_templates_fields_empty = /** @type {(inputs: Templates_Fields_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro tento druh zatím žádný field contract.`)
};

const en_templates_fields_empty = /** @type {(inputs: Templates_Fields_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No field contract for this kind yet.`)
};

/**
* | output |
* | --- |
* | "No field contract for this kind yet." |
*
* @param {Templates_Fields_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_fields_empty = /** @type {((inputs?: Templates_Fields_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Fields_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_fields_empty(inputs)
	return cs_templates_fields_empty(inputs)
});